import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Theme from 'core/themes/model'
import React from 'react'
import FontAwesomeIcon from '../FontAwesomeIcon'

const useStyles = makeStyles((theme: Theme) => ({
  errorMessage: {
    color: theme.palette.red[500],
    display: 'grid',
    gridTemplateColumns: '26px auto',

    '& i': {
      color: theme.palette.red[500],
    },
  },
  errorIcon: {
    alignSelf: 'center',
  },
}))

export const ErrorMessage = ({ className = undefined, children }) => {
  const classes = useStyles({})

  return children ? (
    <div className={clsx(classes.errorMessage, className)}>
      <FontAwesomeIcon className={classes.errorIcon}>exclamation-circle</FontAwesomeIcon>
      <div>{children}</div>
    </div>
  ) : null
}
